import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69f4770f63911b0014e68204/asharecovery/src/app/sign-up-login-screen/components/AuthScreen.tsx");
